import { listDataQualityMetrics } from 'src/api/catalog';
import { generateGlueArnFromId } from 'src/components/utils/arnUtil';
import { FlashbarProps } from '@amzn/awsui-components-react-v3';

export const handleListDataQualityMetrics = async (
  datasetId: string,
  setLoadingDataQuality: any,
  setNotifications: any,
) => {
  setLoadingDataQuality(true);
  try {
    const response = await listDataQualityMetrics({
      ResourceARN: generateGlueArnFromId(datasetId),
      MaxResults: 10,
    });
    return response.DataQualityMetrics;
  } catch (err) {
    console.log(err);
    setNotifications([
      {
        type: 'error' as FlashbarProps.Type,
        content: `Failed to load data quality metrics.`,
        dismissible: true,
        onDismiss: () => setNotifications([]),
      },
    ]);
  }
  setLoadingDataQuality(false);
};
